const HttpClient = require('./core/httpClient');
const { detectButton } = require('./utils/domUtils');
const Transactions = require('./services/transactionsService');
const AuthService = require('./core/authService');
const LoanService = require('./services/loanService');

class AplazoSDK {

  #SUCCESS = 'success';
  #ERROR = 'error';

  constructor({ merchantId, apiToken, isProduction, buttonSelector }) {
    this.client = new HttpClient({ merchantId, apiToken, isProduction })
    this.transactions = new Transactions(this.client)
    this.authService = new AuthService(this.client)
    this.loanService = new LoanService(this.client)
    this.eventHandlers = {};

    if (buttonSelector) {
      DomUtils.attachButtonEvent(buttonSelector, async () => {
        try {
          const data = await this.transactions.getTransactions()
          console.log('Transacciones:', data)
        } catch (error) {
          console.error('Error obteniendo transacciones:', error)
        }
      })
    }
  }

  async getAuth(apiToken, merchantId) {
    try{
      return this.authService.getAuth(apiToken, merchantId)
    } catch (e) {
      throw e
    }

  }

  async createLoan(authToken, loanPayload) {

    return this.loanService
      .createLoan(authToken, loanPayload)
      .then((response) => {
          this.#redirect(response.data);
          return response.data
        })
        .catch((error) => {
          console.error('Error en la llamada a la creación préstamo: ', error.response.data)
          this.#errorRedirect(error.response.data)
          throw error.response.data
        })
  }

  async onSuccessRedirect(callback) {

    if (!this.eventHandlers[this.#SUCCESS]) {
      this.eventHandlers[this.#SUCCESS] = [];
    }
    this.eventHandlers[this.#SUCCESS].push(callback);

  }

  async onErrorRedirect(callback) {
    if (!this.eventHandlers[this.#ERROR]) {
      this.eventHandlers[this.#ERROR] = [];
    }
    this.eventHandlers[this.#ERROR].push(callback);
  }

  #redirect(response) {

    if (typeof window !== "undefined" && response.url) {
      if(!this.eventHandlers[this.#SUCCESS]) {
        console.log('Redirigiendo a:', response.url)
        window.location.href = response.url
      } else {
        this.#fire(this.#SUCCESS, response);
      }
    }
  }

  #errorRedirect(response) {

    if (typeof window !== "undefined") {
      if(!this.eventHandlers[this.#ERROR]) {
        console.error('Ocurrio un error en la llamada al endpoit:', response)
      } else {
        this.#fire(this.#ERROR, response);
      }
    }
  }

  #fire(eventName, data) {
    if (this.eventHandlers[eventName]) {
      this.eventHandlers[eventName].forEach(callback => callback(data));
    }
  }
}

if (typeof module !== "undefined" && module.exports) {
  module.exports = AplazoSDK;
}

if (typeof window !== "undefined") {
  window.AplazoSDK = AplazoSDK;
}

